import { ICONS } from "@assets/icons";

export const CURRENT_LOCATION_MARKER = `<div style="background: no-repeat center url(${ICONS.MARKER.CURRENT}); box-shadow: 0px 8px 32px 0px #353A3F3D; width: 50px; height: 50px; border-radius: 100%;" / >`;
